module.exports = __webpack_public_path__ + "img/mastercard.0c67abb4.png";